import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Autocomplete,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';
import { Delete, Edit, Upload } from '@mui/icons-material';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import api from '../api/axios';

const lib = [
    'sim',
    'não',
]

const sex = [
    'FEMININO',
    'MASCULINO',
    'OUTRO'
]

const situation_list = [ 'PENDENTE', 'FILIADO' ]
const modality_list = [ 'PF', 'PJ' ]
const status_list = [ 'ATIVO', 'LICENCIADO', 'INATIVO', 'ÓBITO' ]

const Usuario = () => {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [tableData, setTableData] = useState({});
  const [cityData, setCityData] = useState([])
  const [companyData, setCompanyData] = useState([])
  const [validationErrors, setValidationErrors] = useState({});

  const getCityList = async () => {
    await api.get('/city/list')
    .then(res => {
        res.data.map((item) => item.label = item.name)
        setCityData(res.data)
    })
    .catch(err => console.log(err))
  }

  const getCompanyList = async () => {
    await api.get('/user/listpj')
    .then(res => {
        res.data.map((item) => item.label = item.name)
        setCompanyData(res.data)
    })
    .catch(err => console.log(err))
  }

  useEffect(() => {
    (async () => {
        await getCityList()
        await getCompanyList()
        await api.get('/user/list')
            .then(res => {
                setTableData(res.data);
                //console.log(res.data)
            })
            .catch(err => console.log(err))
    })();
}, []);

  const handleCreateNewRow = async (values) => {
        if (!values.name) {
            alert('Nome é obrigatório!!!')
            return false;
        }
        if (!values.email) {
            alert('Email é obrigatório!!!')
            return false;
        }
        if (!values.document) {
          alert('Documento do usuário é obrigatório!!!')
          return;
        }
        if (!values.status) {
            alert('Status do usuário é obrigatório!!!')
            return;
        }
        if (!values.situation) {
            alert('Situação do usuário é obrigatório!!!')
            return;
        }
          if (!values.modality) {
            alert('Modalidade do usuário é obrigatório!!!')
            return;
        }
        delete values._id
        if (values.company == '') delete values.company
        await api.post('/user/insert/', values)
        .then(res => {
            tableData.push(res.data);
            setTableData([...tableData]);
        })
        .catch(err => console.log(err))

    };

    const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    if (!Object.keys(validationErrors).length) {
        //values.relacionamento = values.relacionamento == 'sim' ? 'true' : 'false'
        //if (values.company == '') values.company = '000000000000000000000000'
      tableData[row.index] = values;
      //console.log(values)
      await api.put('/user/update/' + values._id, values)
      .then(res => {
          setTableData([...tableData]);
        })
        .catch(err => console.log(err))
      exitEditingMode(); //required to exit editing mode and close modal
    }
  };

  const handleCancelRowEdits = () => {
    setValidationErrors({});
  };

  const handleDeleteRow = useCallback(
    async (row) => {
      if (
        !window.confirm(`Confirma exclusão de ${row.getValue('name')}`)
      ) {
        return;
      }
      //send api delete request here, then refetch or update local table data for re-render
        
    try {
        const response = await api.delete('/user/delete/' + row.getValue('_id'));
        tableData.splice(row.index, 1);
        setTableData([...tableData]);
    } catch (error) {
        if (error.response) {
            console.log(error.response.status);
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log('Error', error.message);
        }
    }
    },
    [tableData],
  );

  const getCommonEditTextFieldProps = useCallback(
    (cell) => {
      return {
        error: !!validationErrors[cell.id],
        helperText: validationErrors[cell.id],
        onBlur: (event) => {
          const isValid =
            cell.column.id === 'email'
              ? validateEmail(event.target.value)
              : cell.column.id === 'age'
              ? validateAge(+event.target.value)
              : validateRequired(event.target.value);
          if (!isValid) {
            //set validation error for cell if invalid
            setValidationErrors({
              ...validationErrors,
              [cell.id]: `${cell.column.columnDef.header} is required`,
            });
          } else {
            //remove validation error for cell if valid
            delete validationErrors[cell.id];
            setValidationErrors({
              ...validationErrors,
            });
          }
        },
      };
    },
    [validationErrors],
  );

  const columns = useMemo(
    () => [
      {
        accessorKey: '_id',
        header: 'ID',
        enableColumnOrdering: false,
        enableEditing: false, //disable editing on this column
        enableSorting: false,
        size: 80,
      },
      {
        accessorKey: 'name',
        header: 'Nome',
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'document',
        header: 'Documento',
        size: 100,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'docaux',
        header: 'Doc auxiliar',
        size: 120,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'phone',
        header: 'Telefone',
        size: 100,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'cellphone',
        header: 'Celular',
        size: 100,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'email',
        header: 'Email',
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
          type: 'email',
        }),
      },
      /*{
        accessorFn: (row) => new Date(row.data_nasc), //convert to Date for sorting and filtering
        accessorKey: 'data_nasc',
        header: 'Data Nascimento',
        enableColumnOrdering: false,
        enableEditing: false, //disable editing on this column
        size: 80,
        Cell: ({ cell }) => cell.getValue()?.toLocaleDateString(), 
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            ...getCommonEditTextFieldProps(cell),
            value: cell.getValue()?.toLocaleDateString()
          }),
      },*/
      {
        accessorKey: 'registration',
        header: 'Matrícula',
        size: 80,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'crdd',
        header: 'CRDD',
        size: 80,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'ordinance',
        header: 'Portaria',
        size: 80,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            ...getCommonEditTextFieldProps(cell),
        }),
      },
      /*{
        //accessorFn: (row) => row.liberado ? 'sim' : 'não',
        accessorKey: 'situation',
        header: 'Situação',
        size: 80,
        muiEditTextFieldProps: ({ cell }) => ({
            children: situation_list.map((situation) => (
                <MenuItem key={situation} value={situation}>
                  {situation}
                </MenuItem>
            )),
            select: true,
        }),
      },*/
      /*{
        //accessorFn: (row) => row.liberado ? 'sim' : 'não',
        accessorKey: 'modality',
        header: 'Modalidade',
        size: 80,
        muiEditTextFieldProps: ({ cell }) => ({
            children: modality_list.map((modality) => (
                <MenuItem key={modality} value={modality}>
                  {modality}
                </MenuItem>
            )),
            select: true,
        }),
      },*/
      {
        //accessorFn: (row) => row.liberado ? 'sim' : 'não',
        accessorKey: 'status',
        header: 'Status',
        size: 80,
        muiEditTextFieldProps: ({ cell }) => ({
            children: status_list.map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
            )),
            select: true,
        }),
      },
      {
        accessorKey: 'address',
        header: 'Endereço',
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'number',
        header: 'Número',
        size: 80,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'cep',
        header: 'CEP',
        size: 80,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'district',
        header: 'Bairro',
        size: 100,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'complement',
        header: 'Complemento',
        size: 100,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'city',
        header: 'Cidade',
        size: 100,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: 'state',
        header: 'UF',
        size: 60,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            ...getCommonEditTextFieldProps(cell),
        }),
      },
      /*{
        //accessorFn: (row) => 'Curitiba',//cityData.filter(city => (city._id == row.city)).name,
        accessorKey: 'city',
        header: 'Município',
        Cell: ({ cell }) => {
            var x = cityData.filter(city => (city._id === cell.getValue()))
            if (x.length > 0) return x[0].name 
            else return ""
        }, 
        muiEditTextFieldProps: ({ cell }) => ({
            children: cityData.map((city) => (
                <MenuItem key={city._id} value={city._id}>
                  {city.name}
                </MenuItem>
            )),
            select: true,
        }),
      },
      {
        //accessorFn: (row) => 'Curitiba',//cityData.filter(city => (city._id == row.city)).name,
        accessorKey: 'enterprise',
        header: 'Empresa',
        Cell: ({ cell }) => {
            var x = companyData.filter(company => (company._id === cell.getValue()))
            if (x.length > 0) return x[0].name 
            else return ""
        }, 
        muiEditTextFieldProps: ({ cell }) => ({
            children: companyData.map((company) => (
                <MenuItem key={company._id} value={company._id}>
                  {company.name}
                </MenuItem>
            )),
            select: true,
        }),
      },*/
    ],
    [getCommonEditTextFieldProps, cityData, companyData],
  );

  return (
    cityData.length > 0 ? (
        <>
      <MaterialReactTable
        displayColumnDefOptions={{
          'mrt-row-actions': {
            muiTableHeadCellProps: {
              align: 'center',
            },
            size: 120,
          },
        }}
        columns={columns}
        data={tableData}
        editingMode="modal" //default
        initialState={{ columnVisibility: { _id: false } }}
        enableColumnOrdering
        enableEditing
        localization={MRT_Localization_PT_BR}
        onEditingRowSave={handleSaveRowEdits}
        onEditingRowCancel={handleCancelRowEdits}
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip arrow placement="left" title="Editar">
              <IconButton onClick={() => table.setEditingRow(row)}>
                <Edit />
              </IconButton>
            </Tooltip>
            <Tooltip arrow placement="right" title="Remover">
              <IconButton color="error" onClick={() => handleDeleteRow(row)}>
                <Delete />
              </IconButton>
            </Tooltip>
            {/*<Tooltip arrow placement="right" title="Upload">
              <IconButton onClick={() => {}}>
                <Upload />
              </IconButton>
            </Tooltip>*/}
          </Box>
        )}
        renderTopToolbarCustomActions={() => (
          <Button
            color='warning'
            onClick={() => setCreateModalOpen(true)}
            variant="contained"
          >
            Criar Novo Usuário
          </Button>
        )}
      />
      <CreateNewAccountModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
        cities={cityData}
        companies={companyData}
        />
    </>) : <></>
  );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({ open, columns, onClose, onSubmit, cities, companies }) => {
  const [values, setValues] = useState(() =>
    columns.reduce((acc, column) => {
      acc[column.accessorKey ?? ''] = '';
      return acc;
    }, {}),
  );

  const handleSubmit = () => {
    //put your validation logic here
    onSubmit(values);
    onClose();
  };

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Criar Novo Usuário</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: '100%',
              minWidth: { xs: '300px', sm: '360px', md: '400px' },
              gap: '1.5rem',
            }}
          >
            {columns.map((column) => (
                column.header != 'ID' ?
                column.header === 'Empresa' ?
					<Autocomplete
						disablePortal
						id="combo-box-demo"
						onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value._id })}
						options={companies}
						renderInput={(params) => <TextField {...params} label="Empresa" />}
					/> :
                column.header === 'Município' ?
					<Autocomplete
						disablePortal
						id="combo-box-demo"
						onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value._id })}
						options={cities}
						renderInput={(params) => <TextField {...params} label="Município" />}
					/> :
                    column.header === 'Modalidade' ?
					<Autocomplete
						disablePortal
						id="combo-box-demo"
						onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value.label })}
						options={[{label: 'PF'}, {label: 'PJ'}]}
						renderInput={(params) => <TextField {...params} label="Modalidade" />}
					/> :
                    column.header === 'Situação' ?
					<Autocomplete
						disablePortal
						id="combo-box-demo"
						onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value.label })}
						options={[{label: 'PENDENTE'}, {label: 'FILIADO'}]}
						renderInput={(params) => <TextField {...params} label="Situação" />}
					/> :
                    column.header === 'Status' ?
					<Autocomplete
						disablePortal
						id="combo-box-demo"
						onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value.label })}
						options={[{label: 'ATIVO'}, {label: 'LICENCIADO'}, {label: 'INATIVO'}]}
						renderInput={(params) => <TextField {...params} label="Status" />}
					/> :
                        <TextField
                        key={column.accessorKey}
                        label={column.header}
                        name={column.accessorKey}
                        onChange={(e) =>
                        setValues({ ...values, [e.target.name]: e.target.value })
                        }
                    /> : <></>
            ))}
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: '1.25rem' }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button color="warning" onClick={handleSubmit} variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const validateRequired = (value) => !!value.length;
const validateEmail = (email) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
const validateAge = (age) => age >= 18 && age <= 50;

export default Usuario;

